import P5Sketch from './P5Sketch'

function App() {
  return (
    <P5Sketch/>
  );
}

export default App;
